<div class="container" [ngStyle]="{ height: graph ? '240vh' : '100vh' }">
  <p class="title" *ngIf="!nav">
    Sailing Performance

    <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial
    Performance<mat-icon class="titleIcon">chevron_right</mat-icon>Database
  </p>
  <p class="title" *ngIf="nav">
    Vessel Performance
    <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial
    Performance<mat-icon class="titleIcon">chevron_right</mat-icon>Fleet
    Performance
  </p>
  <div class="statistics-container" *ngIf="!nav">
    <mat-card class="stat-card total-voyages">
      <div class="card-icon"><mat-icon>anchor</mat-icon></div>
      <mat-card-title>Total Voyages</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ totalVoyages }}</h2>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card total-vessels-count">
      <div class="card-icon"><mat-icon>directions_boat</mat-icon></div>
      <mat-card-title>Total Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ totalVessels }}</h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card active-vessels">
      <div class="card-icon"><mat-icon>check_circle</mat-icon></div>
      <mat-card-title>Active Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ activeVessels }}</h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card inactive-vessels">
      <div class="card-icon"><mat-icon>pause_circle</mat-icon></div>
      <mat-card-title>Inactive Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ inactiveVessels }}
        </h2>
      </mat-card-content>
    </mat-card>

    <mat-card
      class="stat-card fuel-underperf"
      [matTooltip]="fuelTooltipContent || 'No underperforming vessels'"
      matTooltipPosition="above"
    >
      <div class="card-icon"><mat-icon>local_gas_station</mat-icon></div>
      <mat-card-title>Voy Underperf(Fuel)</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ underPerformanceFuel }}
        </h2>
      </mat-card-content>
    </mat-card>
    <mat-card
      class="stat-card time-underperf"
      [matTooltip]="timeTooltipContent || 'No underperforming vessels'"
      matTooltipPosition="above"
    >
      <div class="card-icon"><mat-icon>schedule</mat-icon></div>
      <mat-card-title>Voy Underperf(Time)</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ underPerformanceTime }}
        </h2>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-icon
    class="filter-top-btn"
    (click)="isFilterOpen = true"
    matTooltip="Table Filter"
  >
    filter_list
  </mat-icon>
  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter-panel dark-filter">
      <!-- HEADER -->
      <div class="filter-header">
        <div class="header-left">
          <mat-icon>filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>

        <mat-icon class="close-btn" (click)="isFilterOpen = false">
          close
        </mat-icon>
      </div>

      <!-- BODY -->
      <form [formGroup]="filterForm" class="filter-body">
        <div class="filter-grid">
          <!-- DATE FILTERS -->
          <!-- ================= DATE SECTION ================= -->

          <!-- From Date -->
          <!-- <app-custom-date-picker
            [label]="'From Date:'"
            [controlname]="filterForm.controls['from_date']"
          >
          </app-custom-date-picker> -->

          <!-- To Date -->
          <!-- <app-custom-date-picker
            [label]="'To Date:'"
            [controlname]="filterForm.controls['to_date']"
          >
          </app-custom-date-picker> -->

          <!-- Report From Date -->
          <app-custom-date-picker
            [label]="'Report From Date:'"
            [controlname]="filterForm.controls['reportfrom_date']"
          >
          </app-custom-date-picker>

          <!-- Report To Date -->
          <app-custom-date-picker
            [label]="'Report To Date:'"
            [controlname]="filterForm.controls['reportto_date']"
          >
          </app-custom-date-picker>

          <!-- ================= CLIENT SECTION ================= -->

          <!-- Client Status -->
          <app-custom-dropdown
            [label]="'Client Status:'"
            [items]="clientStatusOptions"
            [controlname]="filterForm.controls['clientStatus']"
          >
          </app-custom-dropdown>

          <!-- Client -->
          <app-pc-multi-select-filter
           [label]="'Client Name:'"
            placeholder="Select Client"
            [options]="apiClientOptions"
            [selected]="selectedClients"
            (selectedChange)="onClientsChanged($event)"
          >
          </app-pc-multi-select-filter>

          <!-- ================= VESSEL SECTION ================= -->

      

          <!-- Type Of Ship -->
          <app-custom-dropdown
            [label]="'Type Of Ship:'"
            [items]="typeofshipOptions"
            [controlname]="filterForm.controls['type_of_ship']"
          >
          </app-custom-dropdown>

          <!-- Segment -->
          <app-custom-dropdown
            [label]="'Segment:'"
            [items]="segmentOptions"
            [controlname]="filterForm.controls['segment']"
          >
          </app-custom-dropdown>

          <!-- Vessel Status -->
          <app-custom-dropdown
            [label]="'Vessel Status:'"
            [items]="statusOptions"
            [controlname]="filterForm.controls['vesselStatus']"
          >
          </app-custom-dropdown>

          <!-- Vessel Name -->
          <app-pc-multi-select-filter
          [label]="'Vessel Name:'"
            placeholder="Select Ship Name"
            [options]="vesselNameOptions"
            [selected]="selectedShips"
            (selectedChange)="onVesselsChanged($event)"
          >
          </app-pc-multi-select-filter>

          <!-- IMO -->
          <app-custom-input
            [label]="'IMO:'"
            [controlname]="filterForm.controls['imo']"
          >
          </app-custom-input>

          <!-- Condition -->
          <app-custom-dropdown
            [label]="'Condition:'"
            [items]="conditionOptions"
            [controlname]="filterForm.controls['condition']"
          >
          </app-custom-dropdown>

          <!-- Type Of Speed -->
          <app-custom-dropdown
            [label]="'Type Of Speed:'"
            [items]="typeofSpeedOptions"
            [controlname]="filterForm.controls['type_speed']"
          >
          </app-custom-dropdown>


              <!-- Commercial Operator -->
          <app-custom-dropdown
            [label]="'Commercial Operator:'"
            [items]="commercialOperatorOptions"
            [controlname]="filterForm.controls['commercial_operator']"
          >
          </app-custom-dropdown>

          <!-- Technical Operator -->
          <app-custom-dropdown
            [label]="'Technical Operator:'"
            [items]="technicalOperatorOptions"
            [controlname]="filterForm.controls['technical_operator']"
          >
          </app-custom-dropdown>
        </div>
      </form>

      <!-- FOOTER -->
      <div class="filter-footer">
        <button class="btn clear-btn" (click)="clearClick()">
          <mat-icon> clear_all </mat-icon>

          Clear Filter
        </button>

        <button class="btn apply-btn" (click)="filterClick()">
          <mat-icon> filter_list </mat-icon>

          Apply Filter
        </button>
      </div>
    </div>
  </div>

  <div class="table-header">
    <h2
      class="tableTitle"
      [ngClass]="{ 'dark-tableTitle': isDarkMode() }"
      *ngIf="!graph && !nav"
    >
      Database Table
    </h2>
    <!-- <div class="toggle" [ngStyle]="{ 'margin-left.px': graph ? 675 : 0 }" *ngIf="!nav">
      <mat-slide-toggle [checked]="graph" (change)="toggleMapView()">{{ graph ? "Table View" : "Fleet Performance " }}
      </mat-slide-toggle>
    </div> -->

    <div class="toolbar" *ngIf="!graph && !nav">
      <button
        mat-icon-button
        color="primary"
        (click)="openColumnFilterDialog()"
        matTooltip="Select table columns"
      >
        <mat-icon>view_column</mat-icon>
      </button>
    </div>
  </div>

  <div
    class="table-container scroll-bar"
    *ngIf="!graph && !nav"
    #tableContainer
  >
    <!-- Loading Overlay -->

    <table
      class="mat-elevation-z8"
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="sticky-header">
        <tr>
          <th
            *ngFor="let col of columns"
            [hidden]="
              !col.visible ||
              ([
                'gw_time',
                'GW_Pcx',
                'avg_speed_in_gw',
                'GW_cons',
                'gwAvgDailyCons',
              ].includes(col.key) &&
                !expandGwMetrics)
            "
            [class.fixed-head]="col.key === 'vessel_name'"
            [mat-sort-header]="col.key !== 'sNo' ? col.key : 'undefined'"
            class="th-text-center3"
          >
            <ng-container *ngIf="col.key === 'gw_distance'; else normalHeader">
              <div class="gw-parent-head">
                <span>{{ col.label }}</span>

                <mat-icon
                  class="expand-icon"
                  (click)="toggleGwMetrics($event)"
                  [matTooltip]="
                    expandGwMetrics ? 'Collapse columns' : 'Expand columns'
                  "
                  matTooltipPosition="above"
                >
                  {{
                    expandGwMetrics
                      ? "remove_circle_outline"
                      : "add_circle_outline"
                  }}
                </mat-icon>
              </div>
            </ng-container>

            <ng-template #normalHeader>
              {{ col.label }}
            </ng-template>
          </th>
        </tr>
      </thead>
      <tbody class="scroll-bar">
       <ng-container *ngIf="isLoadingTable">
    <tr *ngFor="let row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
      <td
        *ngFor="let col of columns"
        [hidden]="
          !col.visible ||
          ([
            'gw_time',
            'GW_Pcx',
            'avg_speed_in_gw',
            'GW_cons',
            'gwAvgDailyCons',
          ].includes(col.key) &&
            !expandGwMetrics)
        "
        [class.fixed-col]="col.key === 'vessel_name'"
      >
        <div
          class="skeleton skeleton-cell"
          [ngClass]="{
            'skeleton-short': col.key === 'sNo' || col.key === 'year_built',
            'skeleton-badge': col.key === 'segment'
          }"
        ></div>
      </td>
    </tr>
  </ng-container>

  <!-- No Data Message -->
  <tr *ngIf="!isLoadingTable && paginatedData.length === 0">
    <td [attr.colspan]="columns.length" class="loader-cell">
      <div class="loader-text">{{ loadingMessage }}</div>
    </td>
  </tr>
        <ng-container *ngIf="!isLoadingTable">
          <tr *ngFor="let element of paginatedData; let rowIndex = index">
            <td
              *ngFor="let col of columns"
              [hidden]="
                !col.visible ||
                ([
                  'gw_time',
                  'GW_Pcx',
                  'avg_speed_in_gw',
                  'GW_cons',
                  'gwAvgDailyCons',
                ].includes(col.key) &&
                  !expandGwMetrics)
              "
              [class.fixed-col]="col.key === 'vessel_name'"
              [ngStyle]="
                ['totalFuelLg', 'totalTimeLg'].includes(col.key)
                  ? { color: getColor(element[col.key]) }
                  : {}
              "
            >
              <ng-container [ngSwitch]="col.key">
                <span *ngSwitchCase="'sNo'">{{
                  currentPage * itemsPerPage + rowIndex + 1
                }}</span>
                <span
                  *ngSwitchCase="'vessel_name'"
                  [ngStyle]="{
                    color: getVesselNameColor(
                      element.totalFuelLg,
                      element.totalTimeLg
                    ),
                  }"
                  matTooltip="{{ formatVesselName(element.vessel_name) }}"
                  >{{
                    element.vessel_name?.length > 10
                      ? (formatVesselName(element.vessel_name)
                          | slice: 0 : 10) + "..."
                      : formatVesselName(element.vessel_name)
                  }}</span
                >
                <span *ngSwitchCase="'imo'">{{ element.imo }}</span>
                <span *ngSwitchCase="'year_built'">{{
                  element.year_built
                }}</span>
                <span *ngSwitchCase="'type_of_ship'">{{
                  element.type_of_ship
                }}</span>
                <span
                  *ngSwitchCase="'segment'"
                  [ngStyle]="getDynamicSegmentStyle(element.segment)"
                  >{{ element.segment }}</span
                >
                <span *ngSwitchCase="'pic'">{{ element.pic }}</span>
                <span *ngSwitchCase="'type_speed'">{{
                  element.type_speed
                }}</span>
                <span *ngSwitchCase="'technical_operator'">{{
                  element.technical_operator
                }}</span>
                <span *ngSwitchCase="'commercial_operator'">{{
                  element.commercial_operator
                }}</span>
                <span
                  *ngSwitchCase="'start_port'"
                  matTooltip="{{ element.start_port }}"
                  >{{
                    element.start_port?.length > 10
                      ? (element.start_port | slice: 0 : 10) + "..."
                      : element.start_port
                  }}</span
                >
                <span
                  *ngSwitchCase="'start_date'"
                  matTooltip="{{ element.start_date }}"
                  >{{
                    element.start_date?.length > 10
                      ? (element.start_date | slice: 0 : 12) + "..."
                      : element.start_date
                  }}</span
                >
                <span
                  *ngSwitchCase="'end_port'"
                  matTooltip="{{ element.end_port }}"
                  >{{
                    element.end_port?.length > 10
                      ? (element.end_port | slice: 0 : 10) + "..."
                      : element.end_port
                  }}</span
                >
                <span
                  *ngSwitchCase="'end_date'"
                  matTooltip="{{ element.end_date }}"
                  >{{
                    element.end_date?.length > 10
                      ? (element.end_date | slice: 0 : 12) + "..."
                      : element.end_date
                  }}</span
                >
                <span *ngSwitchCase="'voyage_type'">{{
                  element.voyage_type
                }}</span>
                <span
                  *ngSwitchCase="'pdf_created'"
                  matTooltip="{{ element.pdf_created }}"
                  >{{
                    element.pdf_created?.length > 10
                      ? (element.pdf_created | slice: 0 : 12) + "..."
                      : element.pdf_created
                  }}</span
                >
                <span *ngSwitchCase="'cp_speed'">{{
                  element.cp_speed | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'cp_consumption'">{{
                  element.cp_consumption | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'daysAtSea'">{{ element.daysAtSea }}</span>
                <span *ngSwitchCase="'totalFuelLg'">{{
                  element.totalFuelLg | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'totalTimeLg'">{{
                  element.totalTimeLg | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'total_distance'">{{
                  element.total_distance | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'total_time'">{{
                  element.total_time | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'total_bunkers_consumed_at_sea'">{{
                  element.total_bunkers_consumed_at_sea | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'avg_speed'">{{
                  element.avg_speed | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'total_avg_daily_cons'">{{
                  element.total_avg_daily_cons | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'gw_distance'">{{
                  element.gw_distance | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'gw_time'">{{
                  element.gw_time | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'GW_Pcx'">{{
                  element.GW_Pcx | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'avg_speed_in_gw'">{{
                  element.avg_speed_in_gw | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'GW_cons'">{{
                  element.GW_cons | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'gwAvgDailyCons'">{{
                  element.gwAvgDailyCons | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'adverse_weather_distance'">{{
                  element.adverse_weather_distance | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'adverse_weather_time'">{{
                  element.adverse_weather_time | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'avg_speed_in_adverse_wx'">{{
                  element.avg_speed_in_adverse_wx | number: "1.2-2"
                }}</span>
                <span *ngSwitchCase="'avg_cons_in_adverser_wx'">{{
                  element.avg_cons_in_adverser_wx | number: "1.2-2"
                }}</span>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <mat-paginator
    [length]="totalRecords"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
    *ngIf="!graph && !nav"
  ></mat-paginator>
  <div class="filtered-count" *ngIf="!graph && !nav && showFilteredCount">
    Filtered Count: {{ filteredCountValue }}
  </div>
  <br />
  <div class="text-right" *ngIf="!graph && !nav">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Download
    </button>
  </div>
  <!-- <div class="graph" *ngIf="graph">
    <div class="row">
      <div class="col-md-6">
        <div class="">
          <div class="header-container">
            <div class="segment-selector">
              <label for="ladenTypeOfShipDropdown">Typ of Ship:</label>
              <select
                id="ladenTypeOfShipDropdown"
                [(ngModel)]="ladenSelectedTypeOfShip"
                (change)="onTypeOfShipChange('Laden')"
              >
                <option
                  *ngFor="let segment of ladenTypeOfShip"
                  [value]="segment"
                >
                  {{ segment }}
                </option>
              </select>
            </div>
            <div class="segment-selector">
              <label for="ladenSegmentDropdown">Segment:</label>
              <select
                id="ladenSegmentDropdown"
                [(ngModel)]="ladenSelectedSegment"
                (change)="onSegmentChange('Laden')"
              >
                <option *ngFor="let segment of ladenSegments" [value]="segment">
                  {{ segment }}
                </option>
              </select>
            </div>

            <div>
              <button (click)="sortLadenChart('Laden')" class="sort-button">
                Sort by Consumption
                <mat-icon class="sortIcon">swap_vert</mat-icon>
              </button>
              <button (click)="azSortChart('Laden')" class="sort-button">
                Sort Alphabetical
                <mat-icon class="sortIcon">swap_vert</mat-icon>
              </button>
            </div>
            <span class="download-link" (click)="downloadCSV('laden')"
              >Download CSV</span
            >
          </div>
          <div *ngIf="!isLoadingLadenChart; else ladenSkeleton">
            <div
              #ladenChartContainer
              [chart]="ladenChart"
              class="graphId"
            ></div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="">
          <div class="header-container">
            <div class="segment-selector">
              <label for="ballastSegmentDropdown">Typ of Ship:</label>
              <select
                id="ballastTypeOfShipDropdown"
                [(ngModel)]="ballastSelectedTypeOfShip"
                (change)="onTypeOfShipChange('Ballast')"
              >
                <option
                  *ngFor="let segment of ballastTypeOfShip"
                  [value]="segment"
                >
                  {{ segment }}
                </option>
              </select>
            </div>
            <div class="segment-selector">
              <label for="ballastSegmentDropdown">Select Segment:</label>
              <select
                id="ballastSegmentDropdown"
                [(ngModel)]="ballastSelectedSegment"
                (change)="onSegmentChange('Ballast')"
              >
                <option
                  *ngFor="let segment of ballastSegments"
                  [value]="segment"
                >
                  {{ segment }}
                </option>
              </select>
            </div>
            <div>
              <button (click)="sortLadenChart('Ballast')" class="sort-button">
                Sort by Consumption
                <mat-icon class="sortIcon">swap_vert</mat-icon>
              </button>
              <button (click)="azSortChart('Ballast')" class="sort-button">
                Sort Alphabetical
                <mat-icon class="sortIcon">swap_vert</mat-icon>
              </button>
            </div>

            <span class="download-link" (click)="downloadCSV('ballast')"
              >Download CSV</span
            >
          </div>
          <div *ngIf="!isLoadingBallastChart; else ballastSkeleton">
            <div
              #ballastChartContainer
              [chart]="ballastChart"
              class="graphId"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="header-container">
      <div class="segment-selector">
        <label for="bothSegmentDropdown">Select Segment:</label>
        <select
          id="bothSegmentDropdown"
          [(ngModel)]="bothSelectedSegment"
          (change)="onSegmentChange('both')"
        >
          <option *ngFor="let segment of bothSegments" [value]="segment">
            {{ segment }}
          </option>
        </select>
      </div>
      <div>
        <button (click)="sortLadenChart('both')" class="sort-button">
          Sort by Consumption
          <mat-icon class="sortIcon">swap_vert</mat-icon>
        </button>
        <button (click)="azSortChart('both')" class="sort-button">
          Sort Alphabetical
          <mat-icon class="sortIcon">swap_vert</mat-icon>
        </button>
      </div>
      <span class="download-link" (click)="downloadCSV('both')"
        >Download CSV</span
      >
    </div>
    <div *ngIf="!isLoadingBothChart; else bothSkeleton">
      <div #bothChartContainer [chart]="bothChart" class="graphId"></div>
    </div>

    <app-tcp-graph></app-tcp-graph>
  </div> -->
</div>

<!-- Global Skeleton Templates -->
<ng-template #statsSkeleton>
  <div class="skeleton-value skeleton"></div>
</ng-template>

<ng-template #ladenSkeleton>
  <div class="skeleton-chart skeleton"></div>
</ng-template>

<ng-template #ballastSkeleton>
  <div class="skeleton-chart skeleton"></div>
</ng-template>

<ng-template #bothSkeleton>
  <div class="skeleton-chart skeleton"></div>
</ng-template>

<!-- <ng-template #tableSkeleton>
  <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
    <td colspan="33">
      <div class="skeleton-table-row skeleton"></div>
    </td>
  </tr>
</ng-template> -->
